<template>
  <div class="page">
    <div class="topmine">
      <div class="topmineleft">
        <img src="../../assets/images/defaultcon.png" class="touxiang" alt="" v-if="!ishead" />
        <img :src="list.BaseInfo.Head" class="touxiang" alt="" v-if="ishead" />
        <div class="nologin" v-if="!islogin" @click="tologin()">
          <span class="zhuce">注册/登录</span>
        </div>
        <div class="nologin" v-else>
          <div class="namerow">
            <div class="name">{{ list.BaseInfo.NickName }}</div>
          </div>
          <div class="jifenrow">
            <!-- <div class="jifen">积分：0</div> -->
          </div>
        </div>
      </div>
      <div class="topmineright">
        <!-- <div class="qd">
          <img src="../../assets/images/qdcon.png" class="qdimg" alt="">
          <div class="qdtext">签到</div>
        </div> -->
      </div>
    </div>

    <!-- <div class="table">
      <div class="tableitem" @click="nopage()">
        <img src="../../assets/images/minesc.png" class="tablecon" alt="">
        <div class="tabletext">我的收藏</div>
      </div>
      <div class="tableitem" @click="nopage()">
        <img src="../../assets/images/mineyy.png" class="tablecon" alt="">
        <div class="tabletext">直播预约</div>
      </div>
      <div class="tableitem" @click="nopage()">
        <img src="../../assets/images/minejf.png" class="tablecon" alt="">
        <div class="tabletext">赚积分</div>
      </div>
      <div class="tableitem" @click="nopage()">
        <img src="../../assets/images/mineshop.png" class="tablecon" alt="">
        <div class="tabletext">积分商城</div>
      </div>
    </div> -->

    <!-- <div class="wcrz">
      <img src="../../assets/images/lin.png" class="wcrzlin" alt="">
      <div class="wcrztext">完成认证即可领取100积分</div>
      <img src="../../assets/images/closebtn.png" class="wcrzclose" alt="">
    </div> -->

    <div class="sfrz">
      <div class="sfleft" @click="jumpnewrenzheng()">
        <div class="sftext">
          <div class="tabletext1">{{ acmedTxt2 }}</div>
          <div class="redback">{{ acmedTxt }}</div>
          <!-- <div class="greytext">({{ sfnum }})</div> -->
        </div>
        <div class="sfimg">
          <img src="../../assets/images/acmedlogonew.png" alt="" class="sfimgin1" />
        </div>
      </div>
      <div class="sfspace"></div>
      <div class="sfright" @click="tomyrz()">
        <div class="sftext">
          <div class="tabletext1">认证中心</div>
          <div>
            <div class="redback">{{ isrz }}</div>
          </div>
        </div>
        <div class="sfimg">
          <img src="../../assets/images/rzzhongxin.png" alt="" />
        </div>
      </div>
    </div>

    <div class="quanzi">
      <div class="sfrow" @click="togrouplist()">
        <div class="qztext">
          <div class="tabletext1">ACMED-临床协作组会员</div>
          <div>
            <div class="redback">{{ xiezuozuzt }}</div>
          </div>
        </div>
        <div class="qzimg">
          <img src="../../assets/images/groupisin.png" alt="" v-if="xiezuozuzt == '点击申请' || xiezuozuzt == '获取中'" />
          <img src="../../assets/images/groupischeck.png" alt="" v-else-if="xiezuozuzt == '审批中'" />
          <img src="../../assets/images/groupisok.png" alt="" v-else-if="xiezuozuzt == '已加入'" />
        </div>
      </div>

      <div class="sfrow" @click="toxinmeiti()">
        <div class="qztext">
          <div class="tabletext1">ACMED-新媒体协作组会员</div>
          <div>
            <div class="redback">{{ xinzt }}</div>
          </div>
        </div>
        <div class="qzimg">
          <img src="../../assets/images/xinisno.png" alt="" v-if="xinzt == '点击申请'" />
          <img src="../../assets/images/xinisno.png" alt="" v-if="xinzt == '已拒绝'" />
          <img src="../../assets/images/xinissh.png" alt="" v-else-if="xinzt == '审批中'" />
          <img src="../../assets/images/xinisok.png" alt="" v-else-if="xinzt == '已加入'" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mixin from '../../common/mixin/mixins'
import { Dialog } from "vant";
export default {
  components: {
    [Dialog.Component.name]: Dialog.Component,
  },
  name: "mine",
  data() {
    return {
      phone: "",
      code: "",
      list: {},
      checked: false,
      sfnum: 0,
      islogin: false,
      ishead: false,
      haveinfo: false,
      isrz: '获取中',
      xiezuozuzt: '获取中',
      info: [
        {
          name: "华山皮肤研学中心",
        },
        {
          name: "医院",
        },
      ],
      acmedTxt: "ACMED",
      acmedTxt2: "",
      choise: 2,
      xinzt: '获取中',
      acmedzt: 0,
      GroupCustomer: [],
      xinclick: 1,
    };
  },
  mixins: [mixin],
  created() {
    this.$store.commit("changeNavbarIndex", 3);
    this.initShare("邀您加入ACMED临床协作组", "点击即可申请");
    this.getinfo();
    this.getmyacmed();
    this.getGroup();
    this.getxiezuozu();
    this.getxinmeiti();
    document.title = "华肤荟";
  },
  methods: {
    getmyacmed() {
      let that = this;
      this.$axios.get("/api/api/web/Customer/GetMyInfo").then((res) => {
        if (!res.Data.ACMEDIdentity) {
          that.acmedzt = 0
        } else {
          if (res.Data.ACMEDIdentity.Status == 70) {
            that.acmedzt = 1
          } else {
            that.acmedzt = 0
          }
        }
      });
    },
    getinfo() {
      this.options = [];
      this.$axios.get("/api/api/web/Customer/GetMyInfo").then((res) => {
        this.list = res.Data;
        sessionStorage.setItem("userInfo", JSON.stringify(res.Data.BaseInfo));
        if (res.Data.BaseInfo.Status != 10 && res.Data.BaseInfo.Status != 20) {
          this.islogin = true;
        }
        if (this.list.BaseInfo.Head) {
          this.ishead = true;
        }
        if (this.list.HFHIdentity == '' || this.list.HFHIdentity == null) {
          this.isrz = '未认证'
        } else if (this.list.HFHIdentity != '' && this.list.HFHIdentity != null && this.list.HFHIdentity.Status == 0) {
          this.isrz = '审核中'
        } else if (this.list.HFHIdentity != '' && this.list.HFHIdentity != null && this.list.HFHIdentity.Status == 20) {
          this.isrz = '已认证'
        } else if (this.list.HFHIdentity != '' && this.list.HFHIdentity != null && this.list.HFHIdentity.Status == 10) {
          this.isrz = '未通过'
        }
        if (this.list.ACMEDIdentity) {
          if (this.list.ACMEDIdentity.Status == 0) {
            this.acmedTxt = "加入ACMED";
            this.acmedTxt2 = "认证中";
          } else if (this.list.ACMEDIdentity.Status == 10) {
            this.acmedTxt = "加入ACMED";
            this.acmedTxt2 = "认证中";
          } else if (this.list.ACMEDIdentity.Status == 20) {
            this.acmedTxt = "加入ACMED";
            this.acmedTxt2 = "认证中";
          } else if (this.list.ACMEDIdentity.Status == 30) {
            this.acmedTxt = "加入ACMED";
            this.acmedTxt2 = "认证中";
          } else if (this.list.ACMEDIdentity.Status == 40) {
            this.acmedTxt = "待缴费";
          } else if (this.list.ACMEDIdentity.Status == 50) {
            this.acmedTxt = "加入ACMED";
            this.acmedTxt2 = "认证中";
          } else if (this.list.ACMEDIdentity.Status == 60) {
            this.acmedTxt = "加入ACMED";
            this.acmedTxt2 = "认证中";
          } else if (this.list.ACMEDIdentity.Status == 70) {
            this.acmedTxt2 = "已加入";
          }
        } else {
          this.acmedTxt = "加入ACMED";
          this.acmedTxt2 = "点击申请";
        }
      });
    },
    getGroup() {
      this.$axios.post('/api/api/web/Customer/GetCollaborativeGroupList', { "KeyWord": "" }).then(res => {
        // console.log(res)
      });
    },
    getxiezuozu() {
      let that = this;
      this.$axios.post('/api/api/web/Customer/GetCollaborativeGroupCustomerList').then(res => {
        // console.log(res)
        that.GroupCustomer = res.Data
        if (res.Data.length == 0) {
          that.choise = 2
        } else if (res.Data.length == 1) {
          // that.choise = 1
          const [s1] = [res.Data[0].CheckStatus];
          const allStatus = new Set([s1]); // 去重判断状态类型
          if ((s1 === 0) || (s1 === 30)) {
            that.choise = 2;
          }
          // 规则3：两个状态都为10 或 都为20
          else if ((s1 === 10) || (s1 === 20)) {
            that.choise = 1;
          }
        } else if (res.Data.length == 2) {
          const [s1, s2] = [res.Data[0].CheckStatus, res.Data[1].CheckStatus];
          const allStatus = new Set([s1, s2]); // 去重判断状态类型
          if ((s1 === 0 && s2 === 0) || (s1 === 30 && s2 === 30)) {
            that.choise = 2;
          }
          // 规则3：两个状态都为10 或 都为20
          else if ((s1 === 10 && s2 === 10) || (s1 === 20 && s2 === 20)) {
            that.choise = 0;
          }
          // 规则2：有一个是10/20（另一个是0/30）
          else if (allStatus.has(10) || allStatus.has(20)) {
            that.choise = 1;
          }
        }
        const status = res.Data;
        if (status.length == 0) {
          that.xiezuozuzt = '点击申请'
        } else if (status.length == 1) {
          if (status[0].CheckStatus == 10) {
            that.xiezuozuzt = '审批中';
          } else if (status[0].CheckStatus === 20) {
            that.xiezuozuzt = '点击申请';
          } else if (status[0].CheckStatus === 30) {
            that.xiezuozuzt = '点击申请';
          }
        } else if (status.length == 2) {
          const [s1, s2] = [res.Data[0].CheckStatus, res.Data[1].CheckStatus];
          const allStatus = new Set([s1, s2]); // 去重判断状态类型
          // 2条全审核中
          if (allStatus.size === 1 && allStatus.has(10)) {
            that.xiezuozuzt = '审批中';
            // console.log('2条数据：全部审核中')
          }
          // 2条全通过
          else if (allStatus.size === 1 && allStatus.has(20)) {
            that.xiezuozuzt = '已加入';
            // console.log('2条数据：全部审核通过')
          }
          // 2条全拒绝
          else if (allStatus.size === 1 && allStatus.has(30)) {
            that.xiezuozuzt = '点击申请';
            // console.log('2条数据：全部审核拒绝')
          }
          // 混合：审核中 + 通过
          else if (allStatus.has(10) && allStatus.has(20)) {
            that.xiezuozuzt = '审批中';
            // console.log('2条数据：审核中 + 审核通过')
          }
          // 混合：审核中 + 拒绝
          else if (allStatus.has(10) && allStatus.has(30)) {
            that.xiezuozuzt = '审批中';
            // console.log('2条数据：审核中 + 审核拒绝')
          }
          // 混合：通过 + 拒绝
          else if (allStatus.has(20) && allStatus.has(30)) {
            that.xiezuozuzt = '点击申请';
            // console.log('2条数据：审核通过 + 审核拒绝')
          }
          // 两条未申请
          else if (allStatus.size === 1 && allStatus.has(0)) {
            that.xiezuozuzt = '点击申请';
            // console.log('2条数据：全部未申请')
          }
          // 混合：未申请 + 通过
          else if (allStatus.has(20) && allStatus.has(0)) {
            that.xiezuozuzt = '点击申请';
            // console.log('2条数据：未申请 + 通过')
          }
          // 混合：未申请 + 审核中
          else if (allStatus.has(10) && allStatus.has(0)) {
            that.xiezuozuzt = '点击申请';
            // console.log('2条数据：未申请 + 审核中')
          }
          // 混合：拒绝 + 未申请
          else if (allStatus.has(30) && allStatus.has(0)) {
            that.xiezuozuzt = '点击申请';
            // console.log('2条数据：拒绝 + 未申请')
          }
        }
      });
      // console.log('协作组状态' + that.xiezuozuzt)
    },
    togrouplist() {
      let that = this
      if (that.acmedzt == 1) {
        if (that.GroupCustomer.length == 0) {
          // if (that.xiezuozuzt != '1') {
          this.$router.push({
            name: "grouplist",
            query: { choise: 2 }
          });
        } else {
          // console.log('bujin')
          this.$router.push({
            name: "groupcheck",
          });
        }
      } else {
        Dialog.confirm({
          title: '提示',
          confirmButtonText: '去注册',
          message:
            '请先申请成为ACMED会员才能成为协作组会员',
        })
          .then(() => {
            this.$axios.get('/api/api/web/Customer/CheckACMEDIdentity').then(res => {
              if (res.Data) {
                this.$router.push('/newok')
              } else {
                this.$router.push('/tuiguang')
              }
            });
          })
          .catch(() => {
            // on cancel
          });
      }
    },
    getxinmeiti() {
      let that = this;
      this.$axios.post('/api/api/web/Customer/GetCollaborativeGroupMediaCustomerCheckStatus').then(res => {
        console.log(res.Data.CheckStatus)
        const xinzt = res.Data.CheckStatus
        if (xinzt == 0) {
          that.xinzt = '点击申请'
        } else if (xinzt == 10) {
          that.xinzt = '审批中'
        } else if (xinzt == 20) {
          that.xinzt = '已加入'
        } else if (xinzt == 30) {
          that.xinzt = '已拒绝'
        }
      });
    },
    toxinmeiti() {
      let that = this;
      if (that.acmedzt == 1) {
        if (that.xinzt == '已加入') {
          this.$router.push('/newscheck')
        } else if (that.xinzt == '审批中') {
          Dialog.alert({
            message: "审批中，请等待审批结果",
          }).then(() => {
            // on close
          });
        } else if (that.xinzt == '点击申请') {
          this.$axios.post('/api/api/web/Customer/BindCollaborativeGroupMediaCustomer').then(res => {
            Dialog.alert({
              message: "申请成功，请等待审批结果",
            }).then(() => {
              // on close
              this.$router.go(0);
            });
          });
        } else if (that.xinzt == '已拒绝') {
          this.$router.push('/newscheck')
        }
      } else {
        Dialog.confirm({
          title: '提示',
          confirmButtonText: '去注册',
          message:
            '请先申请成为ACMED会员才能成为协作组会员',
        })
          .then(() => {
            this.$axios.get('/api/api/web/Customer/CheckACMEDIdentity').then(res => {
              if (res.Data) {
                this.$router.push('/newok')
              } else {
                this.$router.push('/tuiguang')
              }
            });
          })
          .catch(() => {
            // on cancel
          });
      }
      that.xinclick = 0
    },
    goidenttity() {
      this.$router.push({ name: "myidentity" });
    },
    nopage() {
      Dialog.alert({
        message: "升级中，敬请期待！",
      }).then(() => {
        // on close
      });
    },
    tomyrz() {
      let that = this;
      if (that.list.HFHIdentity == '' || that.list.HFHIdentity == null) {
        this.$router.push({ name: "renzhenginfo" });
      } else if (that.list.HFHIdentity != '' && that.list.HFHIdentity != null && that.list.HFHIdentity.Status == 0) {
        Dialog.alert({
          message: "认证审核中，请耐心等待",
        }).then(() => {
          // on close
        });
      } else if (that.list.HFHIdentity != '' && that.list.HFHIdentity != null && that.list.HFHIdentity.Status == 20) {
        this.$router.push({ name: "infocomp" });
      } else if (that.list.HFHIdentity != '' && that.list.HFHIdentity != null && that.list.HFHIdentity.Status == 10) {
        this.$router.push({ name: "infocomp" });
      }
    },
    tologin() {
      if (this.list.BaseInfo.Status == 30) {
        this.$router.push({ name: "compinfo" });
      } else {
        this.$router.push({ name: "login" });
      }
    },
    jumpnewrenzheng() {
      this.$axios.get('/api/api/web/Customer/CheckACMEDIdentity').then(res => {
        if (res.Data) {
          this.$router.push('/newok')
        } else {
          this.$router.push('/tuiguang')
        }
      });
      // this.$router.push("/newrenzheng");
      // this.$dialog
      //   .alert({
      //     title: "提示",
      //     message: "升级中，敬请期待！",
      //   })
      //   .then(() => { });
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  background: rgb(247, 248, 252);
  width: 100%;
  height: 100%;
}

.topmine {
  display: flex;
  flex-direction: row;
  padding: 0.4rem 0;
}

.topmineleft {
  width: 70%;
  padding-left: 5%;
  display: flex;
  flex-direction: row;
  box-sizing: border-box;
}

.touxiang {
  width: 25%;
  display: block;
  border-radius: 50rem;
  aspect-ratio: 1 / 1;
}

.nologin {
  display: flex;
  flex-direction: column;
  align-self: center;
  font-size: 20px;
  margin-left: 0.3rem;
  font-weight: bold;
}

.topmineright {
  width: 30%;
  position: relative;
}

.qd {
  display: flex;
  background: #fff;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 5%;
  padding: 0.1rem;
  border-radius: 50rem;
  width: 33%;
  box-shadow: 0px 4px 6px 0px rgba(255, 224, 169, 0.23);
}

.qdimg {
  width: 35%;
  display: block;
}

.qdtext {
  margin-left: 0.2rem;
  font-size: 14px;
  display: block;
  align-self: center;
  color: #ffa43a;
}

.table {
  background: #fff;
  width: 90%;
  margin: auto;
  border-radius: 4px;
}

.table {
  display: flex;
  flex-direction: row;
  margin-bottom: 0.4rem;
}

.tableitem {
  display: flex;
  flex-direction: column;
  width: 25%;
  margin: 0.4rem 0;
}

.tablecon {
  width: 40%;
  display: block;
  margin: auto;
}

.tabletext {
  text-align: center;
  color: #0c2941;
  margin-top: 0.2rem;
  font-size: 15px;
  font-weight: bold;
}

.wcrz {
  display: flex;
  flex-direction: row;
  background: #fff;
  width: 90%;
  margin: auto;
  border-radius: 4px;
  padding: 0.1rem;
  margin-bottom: 0.4rem;
}

.wcrzlin {
  width: 7%;
}

.wcrzclose {
  width: 7%;
}

.wcrztext {
  width: 85%;
  align-self: center;
  margin: 0 1%;
}

.sfrz {
  display: flex;
  flex-direction: row;
  margin: auto;
  margin-bottom: 0.4rem;
  width: 90%;
}

.sfleft {
  width: 48%;
  background: #fff;
  border-radius: 4px;
  display: flex;
  flex-direction: row;
  padding: 0.2rem 0.2rem;
  box-sizing: border-box;
}

.sfspace {
  width: 4%;
}

.sfright {
  width: 48%;
  background: #fff;
  border-radius: 4px;
  display: flex;
  flex-direction: row;
  padding: 0.2rem 0.4rem;
  box-sizing: border-box;
}

.sftext {
  align-self: center;
  width: 60%;
}

.sfimg {
  width: 40%;
  align-self: center;

  img {
    width: 100%;
    display: block;
  }

  .sfimgin1 {
    width: 87%;
    display: block;
  }
}

.itemtitle {
  color: #0c2941;
  font-weight: bold;
  font-size: 14px;
}

.tabletext1 {
  // text-align: center;
  color: #0c2941;
  // margin-top: 0.2rem;
  font-size: 15px;
  font-weight: bold;
}

.greytext {
  color: #768fa4;
  font-size: 13px;
  margin-top: 0.1rem;
}

.redtext {
  color: #d60c1a;
  font-size: 13px;
}

.redback {
  margin-top: 0.1rem;
  font-size: 0.3rem;
  background: #d60c1a;
  color: #fff;
  display: inline-block;
  padding: 0 0.2rem;
  border-radius: 10px;
  border-top-left-radius: 0;
}

.quanzi {
  width: 90%;
  margin: auto;
}

.quanzititle {
  color: #0c2941;
  // margin-top: 0.2rem;
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 0.3rem;
}

.noitem {
  width: 60%;
  margin: auto;
  display: block;
}

.quanzirow {
  display: flex;
  margin-bottom: 0.3rem;
  background: #fff;
  padding: 0.2rem;
  border-radius: 4px;
}

.quanzicon {
  width: 10%;
}

.quanzitext {
  color: #0c2941;
  font-size: 18px;
  font-weight: bold;
  width: 88%;
  align-self: center;
  margin-left: 2%;
}

.quanziimg {
  width: 100%;
  display: block;
}

.namerow {
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.editimg>img {
  display: block;
  height: 100%;
  margin: auto;
  margin-left: 0.2rem;
}

.jifen {
  font-size: 0.32rem;
  color: #fff;
  background: red;
  display: block;
  width: 2rem;
  text-align: center;
  border-radius: 4rem;
  padding: 0.1rem 0;
  margin: auto;
  margin-top: 0.15rem;
}

.quanzi {
  display: flex;
  flex-direction: column;
  margin: auto;
  margin-bottom: 0.4rem;
  width: 90%;
}

.sfrow {
  width: 100%;
  background: #fff;
  border-radius: 4px;
  display: flex;
  flex-direction: row;
  padding: 0.2rem 0.4rem;
  box-sizing: border-box;
  margin-bottom: .4rem
}

.qzimg {
  width: 17.2%;
  align-self: center;

  img {
    width: 100%;
    display: block;
  }

  .sfimgin1 {
    width: 86.8%;
    display: block;
  }
}

.qztext {
  align-self: center;
  width: 83%;
}
</style>